import _ from "lodash";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  DAILY_SUM_INITIALIZATION,
  GET_DAILY_SUMMARY_USERS,
  DAILY_SUMMARY_USER_SELECTED,
  DAILY_SUMMARY_DATE_CHANGED,
} from "../actions/constant";
import moment from "moment";
import i18n from "../i18n";
import { uuidv4 } from "../services/PublicService";

const initialState = {
  isLoading: false,
  nutritionsList: [],
  mealListAll: [],
  check: false,
  intakes: [],
  burnt: [],
  users: [],
  selectedId: "",
  food: "",
  pcp: "",
  activity: "",
  medication: "",
  location: "",
  temperature: "",
  humidity: "",
  windSpeed: "",
  PM25: "",
  PM10: "",
  Ozone: "",
  NitrogenDioxide: "",
  CarbonMonoxide: "",
  SulfurDioxide: "",
  USEPAAQI: "",
  PrimaryPollutantEPA: "",
  HealthConcernEPA: "",
  ChinaMEPAQI: "",
  PrimaryPollutantMEP: "",
  HealthConcernMEP: "",
  PollenIndexforTrees: "",
  counterState: 0,
  nutrients: [],
  today: "",
  userLang: "",
  selectedDate: "",
};

const ENV_CANONICAL_MAP = {
  temperature: ["Temperature", "温度", "溫度"],
  humidity: ["Humidity", "湿度", "濕度"],
  windspeed: ["Wind Speed", "风速", "風速"],
  pm25: ["PM 2.5", "PM2.5"],
  pm10: ["PM 10", "PM10"],
  ozone: ["Ozone", "臭氧"],
  nitrogendioxide: ["Nitrogen Dioxide", "二氧化氮"],
  carbonmonoxide: ["Carbon Monoxide", "一氧化碳"],
  sulfurdioxide: ["Sulfur Dioxide", "二氧化硫"],
  usepaaqi: ["US EPA AQI", "美国国家环境保护局气品质指标", "美國國家環境保護局氣品質指標"],
  pollen_tree: ["Pollen Index for Trees", "树木花粉指数", "樹木花粉指數"],
  pollen_weed: ["Pollen Index for Weeds", "杂草花粉指数", "雜草花粉指數"],
  pollen_grass: ["Pollen Index for Grass", "草花粉指数", "草花粉指數"],
};

const normalizeEnvItem = (item) => {
  const title = item.title;

  for (const [envKey, titles] of Object.entries(ENV_CANONICAL_MAP)) {
    if (titles.includes(title)) {
      return {
        ...item,
        envKey,
      };
    }
  }

  return null; // unsupported / ignored param
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case getStarted(GET_DAILY_SUMMARY_USERS):
      return { ...state, isLoading: true };
    case getSucceeded(GET_DAILY_SUMMARY_USERS):
      let data = [action.payload.users];
      if (action.payload.users.sub_users)
        data = [action.payload.users, ...action.payload.users.sub_users];
      data = _.orderBy(
        data,
        [(user) => (user.first_name + " " + user.last_name).toLowerCase()],
        ["asc"]
      );
      state.selectedId = action.payload.users._id;
      state.userLang = action.payload.users.lang;
      state.userGroup = action.payload.users.group;
      return {
        ...state,
        users: data,
      };

    case getStarted(DAILY_SUM_INITIALIZATION):
      let startDate = action.payload[0];
      let today = moment().startOf("day").unix() * 1000;
      if (startDate == today) {
        state.today = true;
      } else {
        state.today = false;
      }
      return {
        ...state,
        selectedDate: startDate,
        isLoading: true,
      };

    case getSucceeded(DAILY_SUM_INITIALIZATION):
      if (action.payload.nutrientsList) {
        state.nutritionsList = action.payload.nutrientsList;
      }
      state.data = action.payload.data;
      let intakes = [];
      let burnt = [];
      let food = "";
      let pcp = "";
      let activity = "";
      let medication = "";
      let location = "";
      let humidity = "";
      let temperature = "";
      let windSpeed = "";
      let PM25 = "";
      let PM10 = "";
      let Ozone = "";
      let NitrogenDioxide = "";
      let CarbonMonoxide = "";
      let SulfurDioxide = "";
      let USEPAAQI = "";
      let PrimaryPollutantEPA = "";
      let HealthConcernEPA = "";
      let ChinaMEPAQI = "";
      let PrimaryPollutantMEP = "";
      let HealthConcernMEP = "";
      let PollenIndexforTrees = "";
      let supplements = "";
      if (action.payload.data) {
        if (
          action.payload.data.supplements &&
          action.payload.data.supplements.length > 0
        ) {
          action.payload.data.supplements.map((item, i) => {
            supplements =
              supplements + item + i ==
                action.payload.data.supplements.length - 1
                ? "."
                : ", ";
          });
          state.supplements = supplements;
        } else {
          state.supplements = "";
        }
        action.payload.data.daily_points.map((item) => {
          burnt.push(item.consume_calorie);
          intakes.push(item.receive_calorie);
        });
        if (action.payload.data.food_ingredients.length > 0) {
          action.payload.data.food_ingredients.map((item) => {
            food = food + item.ingredient + ", ";
            state.mealListAll = action.payload.data.food_ingredients;
          });
        } else {
          food = false;
          state.mealListAll = [];
        }
        if (action.payload.data.pcp_ingredients.length > 0) {
          pcp = action.payload.data.pcp_ingredients;
        } else {
          pcp = false;
        }
        if (action.payload.data.activities.length > 0) {
          activity = action.payload.data.activities;
        } else {
          activity = false;
        }
        if (action.payload.data.drugs.length > 0) {

          medication = action.payload.data.drugs;
        } else {
          medication = false;
        }

        if (action.payload.data.locations.length > 0) {
          action.payload.data.locations.forEach((item, i) => {
            let locName = item.name;
            let locData = item.data;

            let isEmptyLocData = Object.keys(locData).length === 0;

            if (!isEmptyLocData) {
              const filteredData = locData
                .map(normalizeEnvItem)
                .filter(Boolean)
                .filter(item => item.value !== "NA")
                .map(item => {
                  switch (item.envKey) {
                    case "temperature":
                      item.unit = "°C";
                      break;
                    case "humidity":
                      item.unit = "%";
                      break;
                    case "windspeed":
                      item.unit = "m/s";
                      break;
                    case "pm25":
                    case "pm10":
                      item.unit = "μg/m3";
                      break;
                    case "ozone":
                    case "nitrogendioxide":
                    case "sulfurdioxide":
                      item.unit = "ppb";
                      break;
                    case "carbonmonoxide":
                      item.unit = "ppm";
                      break;
                    default:
                      item.unit = "";
                  }
                  return item;
                });

              // Construct the location string with available data
              action.payload.data.locations[i].data = filteredData;
            }
            location = action.payload.data.locations;
          });
        } else {
          location = false;
        }
      }
      state.nutrients = action.payload.data.nutrients;
      state.baseNutrientsList = action.payload.nutrientsList;

      function showingNutrientsArea(baseNutrientsList = [], allItems) {
        let nutList = [...baseNutrientsList];
        nutList.forEach((nut) => {
          let sum = 0;
          let fillItems = state.nutrients;
          let selItcheck = {};
          if (fillItems) {
            selItcheck = fillItems.filter(
              (nutf) => nutf._id.$numberLong == nut._id
            );
          }
          if (selItcheck && selItcheck.length > 0) {
            //fillItems.push(selIt);
            sum = sum + selItcheck[0].value;
          }
          // nut.sum = twoDecimals(sum);
          if (sum == 0) {
            nut.sum = 0;
          } else if (sum != 0 && sum < 1) {
            nut.sum = sum.toPrecision(2);
          } else if (sum >= 1 && sum < 100) {
            nut.sum = sum.toFixed(1);
          } else if (sum >= 100) {
            nut.sum = Math.floor(sum);
          }
          if (nut.max > 0) {
            nut.percentage = ((nut.sum * 100) / nut.max).toFixed();
          } else {
            nut.percentage = "N/A";
          }

          // Mark bold & indent flags for styling in the UI
          const BOLD_IDS = new Set([
            "1400600000001000001", // Calorie
            "1400600000001000002", // Total Fat
            "1400600000001000056", // Cholesterol
            "1400600000001000061", // Sodium
            "1400600000001000062", // Total Carbohydrate
            "1400600000001000083", // Protein
          ]);
          const INDENT_IDS = new Set([
            "1400600000001000003", // Saturated Fat
            "1400600000001000018", // Trans Fat
            "1400600000001000063", // Dietary Fiber
            "1400600000001000067", // Sugars
          ]);

          if (BOLD_IDS.has(nut._id)) nut.bold = true;
          if (INDENT_IDS.has(nut._id)) nut.ind = 1;   // 1 means "indent this line"
        });
        return nutList;
      }

      if (action.payload.data.nutrients) {
        state.nutritionsList = showingNutrientsArea(
          action.payload.nutrientsList,
          state.mealListAll
        );
      }
      burnt = burnt.map((num) => {
        let noDecimal = Math.floor(num);
        return noDecimal;
      });
      intakes = intakes.map((num) => {
        let noDecimal = Math.floor(num);
        return noDecimal;
      });
      state.check = true;
      console.log(location)
      return {
        ...state,
        isLoading: false,
        intakes: intakes,
        burnt: state.userGroup == "1100" ? burnt : [],
        food: food,
        pcp: pcp,
        activity: activity,
        medication: medication,
        location,
        humidity,
        windSpeed,
        PM25,
        PM10,
        Ozone,
        NitrogenDioxide,
        CarbonMonoxide,
        SulfurDioxide,
        USEPAAQI,
        PrimaryPollutantEPA,
        HealthConcernEPA,
        ChinaMEPAQI,
        PrimaryPollutantMEP,
        HealthConcernMEP,
        PollenIndexforTrees,
        temperature,
        counterState: state.counterState + 1,
      };
    case getFailed(DAILY_SUM_INITIALIZATION):

    case getEnded(DAILY_SUM_INITIALIZATION):
      return {
        ...state,
      };

    case DAILY_SUMMARY_USER_SELECTED:
      let selectedId = action.data._id;
      let userGroup = action.data.group;
      return {
        ...state,
        selectedId: selectedId,
        userGroup: userGroup,
      };

    case DAILY_SUMMARY_DATE_CHANGED:
      state.startDate = action.val;
      state.selectedDate = moment(state.startDate).startOf("day").unix() * 1000;
      return {
        ...state,
        counterState: state.counterState + 1,
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/dailyInputSummaryReducer.js